import ZoomVideo from "@zoom/videosdk";

export const client = ZoomVideo.createClient()
